import view from "../../views/header.js";
import KTAPI from "../api/index.api.js";
import { _user, _handler, TimeAgoUpdater, storage, Toasted } from "../classes/index.classes";
import { router, toggleLoader } from "../router/index.routes";
import { KTLang } from "../lang/lang.js";



const isTokenExpired = (token) => {try{let a = Date.now() >= (JSON.parse(atob(token.split('.')[1]))).exp * 1000; return a;}catch(e){return true;}};



let logibtn = /*html*/ `
    <div class="d-flex align-items-center ms-1 ms-lg-3">
        <div class="btn btn-sm btn-light-info btn-active-light-info btn-sign"><i class="fab fa-steam fs-1"></i> <span class="" data-i18n="nav.login">Login with Steam</span></div>
    </div>
`;
let clientbtn = /*html*/ `
    <div class="d-flex align-items-center ms-1 ms-lg-3">
        <a href="services/client" data-navigo class="btn btn-sm btn-light-primary btn-active-primary btn-active-color-gray-200"><span data-i18n="nav.client" class="">Download Client</span><span class="ms-2 badge badge-primary">New!</span></a>
    </div>
`;


let newsPagination = {
    page: null,
    nextPage: null,
    prevPage: null,
    hasNextPage: null,
    hasPrevPage: null,
    limit: null,
    totalDocs: null,
    totalPages: null,
    loading: false
};

let unreadNewsCount = 0;

const bgColors = {announcement: 'light-primary', new: 'light-info', event: 'light-danger', update: 'light-success'};

let header = {
    render: () => {
        
        return view;
    },
    after_render: async () => {
        //const token = KTCookie.get("token");
        new KTMenu($("#user-menu-search")[0]);
        new KTMenu($("#user-menu-news")[0]);

        initNewsMenu();
        initSearchBar();

        if(!_user.authed)
        {  
            //$("#kt_header_buttons").html('');
            //$("#kt_header_buttons").html(logibtn);
            $("#kt_header_buttons").find(".auth-required").remove();
            $("#kt_header_buttons").append(logibtn);
        }
        else
        {
            //if(KTAPI.me.steamid === undefined)
            //{
            //    KTAPI.me = await KTAPI.getMe();
            //}
            $(".user-img").attr("src",_user.me.avatar);
            $(".user-nick").text(_user.me.nickname);
            $(".user-steamid").attr("href","https://steamcommunity.com/profiles/"+_user.me.communityid+"/").html(_user.me.steamid);
            $(".user-profile").attr("href",`user/${_user.me.username === undefined || _user.me.username == '' || _user.me.username == null ? _user.me.communityid : _user.me.username}`).attr("data-navigo", "");
            $(".user-settings").attr("href",`user/${_user.me.username === undefined || _user.me.username == '' || _user.me.username == null ? _user.me.communityid : _user.me.username}/settings`).attr("data-navigo", "");

            $(".dismiss-user-menu").off("click");
            $(".dismiss-user-menu").on("click", () => {
                $(".user-menu").trigger("click");
            });

            //new KTMenu("user-menu-toggle");
            new KTMenu($("#user-menu-toggle")[0]);            
        }

        //if(!window.isDesktopApp) $("#kt_header_buttons").prepend(clientbtn);
        await router.updatePageLinks();

        
    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_header',
};
let joining = 0;
$(document).ready(function(){
    $(document).on("click", ".btn-sign", function(e) {
        
        e.preventDefault();
        if(joining == 0) window.location.href = "https://oldapi.pdxplay.org/auth/steam";
        joining++;

    });   
});

function initNewsMenu()
{
    newsPagination.page = 1;
    newsPagination.limit = 5;
    newsPagination.loading = true;
    toggleLoader(".user-menu-news-list");
    let newsRead = storage.get("newsRead") || [];
    KTAPI.getNews({page:newsPagination.page, limit: newsPagination.limit, menu: true}).then((data) => {
        /*$(".user-menu-news-list").html('');
        data.forEach((item) => {
            $(".user-menu-news-list").append(newsItem(item));
        });*/
        //console.log("GOT NEWS: ", data);
        if(data.news.docs.length > 0)
        {
            data.news.docs.forEach((item) => {
                if(!newsRead.includes(item._id)) unreadNewsCount++;
                $(".user-menu-news-list").append(renderNew(item));
            });
            newsPagination.page = data.news.page;
            newsPagination.nextPage = data.news.nextPage;
            newsPagination.prevPage = data.news.prevPage;
            newsPagination.hasNextPage = data.news.hasNextPage;
            newsPagination.hasPrevPage = data.news.hasPrevPage;
            newsPagination.totalDocs = data.news.totalDocs;
            newsPagination.totalPages = data.news.totalPages;
            
        }
        toggleLoader(".user-menu-news-list");
        renderBadgeUnreadNews();
    });    
}

const renderNew = (data, forceunread = false, markasread = false) =>
    {
        let newsRead = storage.get("newsRead") || [];
        let read = forceunread ? false : newsRead.includes(data._id);

        let titleColor = read ? 'text-gray-700' : 'text-gray-900';
        let dateColor = read ? 'text-muted' : 'text-primary';

        if(markasread)
        {
            $(".news-menu-new[data-new='"+data._id+"']").find(".pulse").remove();
            $(".news-menu-new[data-new='"+data._id+"']").find(".news-title").removeClass("text-gray-900").addClass("text-gray-700");
            $(".news-menu-new[data-new='"+data._id+"']").find(".news-date").removeClass("text-primary").addClass("text-muted");
            return;
        }

        

        let titles = ``;
        const lang = KTLang.getLang();

        Object.keys(data.translations).map(key => {
            titles+=`<span class="news-lang ${lang == key ? '' : 'd-none'}" lang="${key}">${data.translations[key].title}</span>`;            
        });

        let htm = /*html*/`
            <!--begin::Item-->
            <div class="d-flex flex-stack py-3 bg-state-white bg-state-opacity-5 mx-n3 px-4 rounded mb-3 news-menu-new" data-new="${data._id}">
                <!--begin::Section-->
                <div class="d-flex flex-column align-items-start">
                    <!--begin::Code-->
                    <div class="d-flex ${read ? '' : 'justify-content-between'} position-relative w-100 align-items-center">
                        <span class="badge badge-sm badge-${bgColors[data.category]} fw-bold my-2 text-uppercase" data-i18n="news.${data.category}">${data.category}</span>
                        ${read ? '' : '<div class="btn btn-icon position-relative w-25px h-25px w-md-35px h-md-35px pulse pulse-primary"><i class="fas fa-circle text-primary fs-8"></i><span class="pulse-ring w-30px h-30px border-2"></span></div>'}
                    </div>  
                    <!--end::Code-->

                    <!--begin::Title-->                    
                    <a href="news/${data.slug}" data-navigo class="fw-semibold ${titleColor} text-hover-white overflow-hidden fs-7 news-title" style="display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;">${titles}</a>
                    <!--end::Title-->

                    <!--begin::Label-->                
                    <span class="mt-1 ${dateColor} fs-9 timer-${data.createdAt} news-date" moment-timestamp="${parseInt(parseInt(data.createdAt))+hostStampDif}" data-toggle="tooltip" title=""></span>
                    <!--end::Label-->
                </div>
                <!--end::Section-->

                
            </div>
            <!--end::Item-->
        `;
        htm = $(htm);
        new TimeAgoUpdater(htm.find(".timer-"+data.createdAt));
        htm.localize();
        htm.find("[data-i18n-options]").text(function(i, text) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        });
        return htm;
    }

const renderBadgeUnreadNews = (action = '', id = '') =>
{
    if(action == 'add') unreadNewsCount++;
    else if(action == 'remove') 
        {
            unreadNewsCount--;
        }

    if(unreadNewsCount > 0)
    {
        $(".user-menu-news-badge").removeClass("d-none").text(unreadNewsCount);
    }
    else
    {
        $(".user-menu-news-badge").addClass("d-none");
    }

}

const updateHeader = async (data) => {
    $(".user-img").attr("src",data.avatar);
    $(".user-nick").text(data.nickname);
    $(".user-steamid").attr("href","https://steamcommunity.com/profiles/"+data.communityid+"/").html(data.steamid);
    $(".user-profile").attr("href",`user/${data.username === undefined || data.username == '' || data.username == null ? data.communityid : data.username}`).attr("data-navigo", "");
    $(".user-settings").attr("href",`user/${data.username === undefined || data.username == '' || data.username == null ? data.communityid : data.username}/settings`).attr("data-navigo", "");
    await router.updatePageLinks();
};

_handler.on('update-user', async (data) => {
    //console.log("Update User", data);
    updateHeader(data);
});

export default header;
export { updateHeader, renderBadgeUnreadNews, renderNew }

/**
 * 
 *  SOCKET.IO PROCESSESS
 * 
 */

const headerSocket = (socket) => {

    //console.log("PUG SOCKET");
        
    socket.on("news", async (data) => {

        //console.log(`"NEWS SOCKET ${typeof data}"`, data);
        if(data.event == 'save')
        {
            $(".user-menu-news-list").append(renderNew(data.data, true));
            renderBadgeUnreadNews('add');
            Toasted.showInfo("a new announcement has been published <a href='news/"+data.data.slug+"' data-navigo>Read more</a>");
            router.updatePageLinks();
        }
    });   
    
};

export { headerSocket };


/**
 * 
 * 
 * SEARCH BAR
 * 
 * 
 */
var searchMenu = null;
let onSearch = false;

async function initSearchBar()
{
    if(searchMenu != null) 
    {
        searchMenu.off("kt.menu.dropdown.shown");
        searchMenu.off("kt.menu.dropdown.hidden");
    }

    let recentSearches = await KTAPI.getRecentSearches();    
    if(recentSearches.length > 0)
    {
        $(".user-menu-search-recent-list").html('');
        recentSearches.forEach((item) => {
            $(".user-menu-search-recent-list").append(searchItem(item.user));
        });
        //$(".user-menu-search-recent").removeClass("d-none");
    }

    searchMenu = KTMenu.getInstance($("#user-menu-search")[0]);
    
    searchMenu.on("kt.menu.dropdown.shown", function(e){
        $("#user-menu-search-input").focus();
    });

    searchMenu.on("kt.menu.dropdown.hidden", function(e){
        searchMenuReset();
    });

    $(".user-menu-search-reset").off("click");
    $(".user-menu-search-reset").on("click", function(e){
        searchMenuReset();
        $("#user-menu-search-input").focus();
    });

    $("#user-menu-search-input").off("input");
    $("#user-menu-search-input").on("input", async function(e){
        let val = $(this).val();

        if(val.length > 0 && val.length < 3)
        {
            $(".user-menu-search-results").addClass("d-none");
            $(".user-menu-search-recent").removeClass("d-none");            
        }

        if(val.length == 0)
        {
            $(".user-menu-search-reset").addClass("d-none");
            return;
        }
        if(val.length > 0 && val.length < 3)
        {
            $(".user-menu-search-reset").removeClass("d-none");
            return
        }
        
        if(onSearch) return;
        
        onSearch = true;
        $(".user-menu-search-reset").addClass("d-none");
        $(".user-menu-search-spinner").removeClass("d-none");


        let res = await KTAPI.search({pattern: val});
        $(".user-menu-search-recent").addClass("d-none");
        //$(".user-menu-search-results").removeClass("d-none");
        if(res.totalDocs !== undefined && res.totalDocs > 0)
        {
            $(".user-menu-search-results-num").text(res.totalDocs);
            $(".user-menu-search-results-list").html('');
            res.docs.forEach((item) => {
                $(".user-menu-search-results-list").append(searchItem(item));
            });
            $(".user-menu-search-empty").addClass("d-none");
            $(".user-menu-search-results").removeClass("d-none");
        }
        else
        {
            $(".user-menu-search-results").addClass("d-none");
            $(".user-menu-search-empty").removeClass("d-none");
        }

        $(".user-menu-search-spinner").addClass("d-none");
        $(".user-menu-search-reset").removeClass("d-none");
        onSearch = false;
    });

    $(".user-menu-search-form").off("submit");
    $(".user-menu-search-form").on("submit", function(e){
        e.preventDefault();
        return false;
    });


    function searchMenuReset()
    {
        $("#user-menu-search-input").val('');
        $(".user-menu-search-reset").addClass("d-none");
        $(".user-menu-search-spinner").addClass("d-none");
        $(".user-menu-search-results").addClass("d-none");
        $(".user-menu-search-recent").removeClass("d-none");
    }

}

function searchItem(data)
{
    let htm = /*html*/
    `
        <div class="d-flex flex-stack px-4 py-3 bg-state-white bg-state-opacity-5 rounded">                    
            <div class="d-flex align-items-center w-100">                        
                <div class="symbol symbol-35px popover-profile" data-steamid="${data.steamid}">
                    <img src="${data.avatar === undefined || data.avatar == '' ? 'assets/media/avatars/default.jpg' : data.avatar}" class="" alt="">
                </div>
                
                <div class="ms-4 text-truncate fs-7">
                    <a href="user/${data.communityid}" data-navigo class="d-flex align-items-center fw-bold text-gray-800 text-hover-white">
                    <img class="me-2 pflag" height="12" width="18" src="assets/media/flags/${data.countrycode.toLowerCase()}.gif" data-toggle="tooltip" title="${data.city} ${data.country}"/><span class="fnick text-truncate" style="min-width:0;"></span>
                    </a>
                    <div class="fw-semibold text-muted">                        
                        <a href="https://steamcommunity.com/profiles/${data.communityid}/" target="_blank" class="fw-semibold text-truncate text-muted text-hover-gray-700" style="min-width:0;">${data.steamid}</a>
                    </div>
                </div>
            </div>
        </div>
    `;
    htm = $(htm);
    htm.find(".fnick").text(data.nickname);
    htm.localize();
    htm.find("[data-toggle='tooltip']").tooltip();
    htm.find("[data-toggle='tooltip']").attr("title", "");
    return htm;
}